export default "__VITE_ASSET__fab73c3c__"